// test2768
(2768 && 0);
